import { HttpErrorResponse } from '@angular/common/http';
import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {OverlayPanel} from 'primeng/overlaypanel';
import {TemplateHtmlService} from '../../page/marketing/template-html/template-html.service';
import {ConfiguratorTemplateHtmlService, TemplateHtmlDTO} from '@tj/tj-dmp-lib-api';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'dmp-select-template-html',
    templateUrl: './select-template-html.component.html',
    styleUrls: ['./select-template-html.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectTemplateHtmlComponent
        }
    ],
    standalone: false
})
export class SelectTemplateHtmlComponent implements OnChanges, ControlValueAccessor {
    @Input() disabled = false;
    @Input() datastore: string;
    @ViewChild('op') overlayPanel: OverlayPanel;

    sourceTemplates: TemplateHtmlDTO[];

    targetTemplates: TemplateHtmlDTO[] = [];

    currentTemplate: TemplateHtmlDTO;

    styleCol = {
        height: '200px',
        with: '150px'
    };

    touched = false;
    private value: Array<string>;

    public load = false;

    constructor(
        private readonly templateHtmlService: TemplateHtmlService,
        private readonly configuratorTemplateHtmlService: ConfiguratorTemplateHtmlService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.datastore) {
            this.targetTemplates = [];
            this.sourceTemplates = [];
            this.configuratorTemplateHtmlService.getAllTemplateHtmlsUsingGET(this.datastore)
                .subscribe(
                    (res: TemplateHtmlDTO[]) => {
                        if (res) {
                            res
                                .filter(t => t.enable === true)
                                .forEach(t => {
                                    if (this.value.includes(t.code)) {
                                        this.targetTemplates.push(t);
                                    } else {
                                        this.sourceTemplates.push(t);
                                    }
                                });
                            this.load = true;
                        }
                    },
                    (res: HttpErrorResponse) => this.onError(res.message)
                );
        }
    }

    show(event, template: TemplateHtmlDTO): void {
        this.currentTemplate = template;
        this.overlayPanel.show(event);
    }

    protected onError(errorMessage: string) {
        console.error(errorMessage);
    }

    onChange: any = () => {/**/
    };
    onTouch: any = () => {/**/
    };

    writeValue(item: Array<string>): void {
        this.value = item;
        this.updateValue();
    }

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouch = onTouched;
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouch();
            this.touched = true;
        }
    }

    public updateValue() {
        const codes = this.targetTemplates.map(i => i.code);
        this.onChange(codes);
        this.onTouch(codes);
    }
}
